import type { IssueId } from '../../../../model/issue';
import type { PercentPosition } from '../../common/utils/timeline';

type Props = {
	id: IssueId;
	getPositionFromDate: (date: Date) => PercentPosition;
};

function ChartIndicators(_: Props) {
	return null;
}

export default ChartIndicators;

export type { Props as APIProps };
